import { IRoute } from "./bean/RouteBean";
import FreeMintPage from "./pages/FreeMintPage";
import CopyrightMarket from "./pages/CopyrightMarket";
import IPListPage from "./pages/IPListPage";
import MintIPInfo from "./pages/MintIPInfo";
import OnePage from "./pages/OnePage";
import LicensePage from "./pages/LicensePage";
import UserCenter from "./pages/UserCenter";
import BrandInfo from "./pages/BrandInfo";
import NFTBrands from "./pages/NFTBrands";
import IPLManagement from "./pages/IPLManagement";
import IPLPublish from "./pages/IPLPublish";
import IPLEdit from "./pages/IPLEdit";

export const enum MythRouteId {
    MythPASS = 1, BuyAPASS = 1.1, FreeMintList = 1.2,
    FreeMintPage = 2,
    IpMarket = 3, ExploreIpMarket = 3.1, SubmitYourWorks = 3.2,
    IPListPage = 4, MintIPInfo, OnePage, LicensePage, BrandInfo,
    NFTBrands = 9, ExploreNFTBrands = 9.1, SubmitYourBrand = 9.2,
    IPLicensingCard = 10, LaunchIPLCards = 10.1, ManageIPLCards = 10.2,
    UserCenter = 11,
    Support,
    IPLManagement, IPLPublish, IPLEdit
}

const routes: IRoute[] = [
    // {
    //     id: MythRouteId.MythPASS,
    //     path: "",
    //     meta: { icon: "card", title: "Myth PASS" },
    //     hidden: false,
    //     isLink: false,
    //     children: [
    //         {
    //             id: MythRouteId.BuyAPASS,
    //             path: "/buy-a-pass",
    //             meta: { icon: "", title: "Buy a PASS" },
    //             component: MythPASS,
    //             hidden: false,
    //             isLink: false,
    //         },
    //         {
    //             id: MythRouteId.FreeMintList,
    //             path: "/free-mint-list",
    //             meta: { icon: "", title: "FreeMint List" },
    //             component: LaunchPad,
    //             hidden: false,
    //             isLink: false,
    //         }
    //     ]
    // },
    {
        id: MythRouteId.IpMarket,
        path: "",
        meta: { icon: "Licensing-market", title: "Licensing Market" },
        component: '',
        hidden: false,
        isLink: false,
        children: [
            {
                id: MythRouteId.ExploreIpMarket,
                path: "/licensing-market",
                meta: { icon: "", title: "Explore Licensing Market" },
                component: CopyrightMarket,
                hidden: false,
                isLink: false,
            },
            {
                id: MythRouteId.SubmitYourWorks,
                path: "https://forms.gle/6TZZX1um1vWUgvo16",
                meta: { icon: "", title: "Submit your works" },
                component: '',
                hidden: false,
                isLink: true,
                isHref: true
            }
        ]
    },
    {
        id: MythRouteId.NFTBrands,
        path: "",
        meta: { icon: "nft-brands", title: "NFT Brands" },
        component: '',
        hidden: false,
        isLink: false,
        children: [
            {
                id: MythRouteId.ExploreNFTBrands,
                path: "/nft-brands",
                meta: { icon: "", title: "Explore NFT brands" },
                component: NFTBrands,
                hidden: false,
                isLink: false,
            },
            {
                id: MythRouteId.SubmitYourBrand,
                path: "https://forms.gle/6HnwJHGBT35ff2vx8",
                meta: { icon: "", title: "Submit your brand" },
                component: '',
                hidden: false,
                isLink: true,
                isHref: true
            }
        ]
    },
    {
        id: MythRouteId.IPLicensingCard,
        path: "",
        meta: { icon: "card1", title: "IP-Licensing Card" },
        component: '',
        hidden: false,
        isLink: false,
        children: [
            {
                id: MythRouteId.LaunchIPLCards,
                path: "/launch-ipl-cards",
                meta: { icon: "", title: "Launch IPL Cards" },
                component: IPLPublish,
                hidden: false,
                isLink: false,
            },
            {
                id: MythRouteId.ManageIPLCards,
                path: "/manage-ipl-cards",
                meta: { icon: "", title: "Manage IPL Cards" },
                component: IPLManagement,
                hidden: false,
                isLink: false,
                isHref: false
            }
        ]
    },
    {
        id: MythRouteId.UserCenter,
        path: "/user-center",
        meta: { icon: "user-center", title: "User Center" },
        component: UserCenter,
        hidden: false,
        isLink: false,
    },
    // {
    //     id: MythRouteId.Support,
    //     path: "",
    //     meta: { icon: "support", title: "Support" },
    //     component: "",
    //     hidden: false,
    //     isLink: true,
    //     isHref: false
    // },
    {
        id: MythRouteId.FreeMintPage,
        path: "/free-mint",
        meta: { icon: "", title: "" },
        component: FreeMintPage,
        hidden: true,
        isLink: false,
    },
    {
        id: MythRouteId.IPListPage,
        path: "/ip-list",
        meta: { icon: "", title: "" },
        component: IPListPage,
        hidden: true,
        isLink: false,
    },
    {
        id: MythRouteId.MintIPInfo,
        path: "/mint-ip",
        meta: { icon: "", title: "" },
        component: MintIPInfo,
        hidden: true,
        isLink: false,
    },
    {
        id: MythRouteId.OnePage,
        path: "/one-page",
        meta: { icon: "", title: "" },
        component: OnePage,
        hidden: true,
        isLink: false,
    },
    {
        id: MythRouteId.LicensePage,
        path: "/license-page",
        meta: { icon: "", title: "" },
        component: LicensePage,
        hidden: true,
        isLink: false,
    },
    {
        id: MythRouteId.BrandInfo,
        path: "/brand-info",
        meta: { icon: "", title: "" },
        component: BrandInfo,
        hidden: true,
        isLink: false,
    },
    {
        id: MythRouteId.IPLManagement,
        path: "/ipl-management",
        meta: { icon: "", title: "IP Licensing Management" },
        component: IPLManagement,
        hidden: true,
        isLink: false,
    },
    {
        id: MythRouteId.IPLPublish,
        path: "/ipl-publish",
        meta: { icon: "", title: "IP License Publish" },
        component: IPLPublish,
        hidden: true,
        isLink: false,
    }, {
        id: MythRouteId.IPLEdit,
        path: "/ipl-edit",
        meta: { icon: "", title: "IP License Edit" },
        component: IPLEdit,
        hidden: true,
        isLink: false,
    },
    {
        id: MythRouteId.ExploreIpMarket,
        path: "/",
        meta: { icon: "", title: "Explore ip Market" },
        component: CopyrightMarket,
        hidden: true,
        isLink: false,
    }
];

const formatRoutes = (routes: IRoute[]) => {
    let routeList = new Array(0);
    routes.forEach((route: IRoute) => {
        if (!route.children) {
            routeList.push({
                id: route.id,
                path: route.path,
                component: route.component,
                meta: route.meta,
                hidden: route.hidden,
                isLink: route.isLink,
                isHref: route.isHref
            })
        } else {
            formatRoutesChildren(route.children, routeList, route.path);
        }
    })
    return routeList;
}

const formatRoutesChildren = (children: IRoute[], list: IRoute[], path: string) => {
    children.forEach((child: IRoute) => {
        if (!child.children) {
            list.push({
                id: child.id,
                path: path + child.path,
                component: child.component,
                meta: child.meta,
                hidden: child.hidden,
                isLink: child.isLink,
                isHref: child.isHref
            })
        } else {
            formatRoutesChildren(child.children, list, path + child.path);
        }
    })
};

export function getRoutePath(routeId: number): string {
    const route: IRoute | undefined = routerList.find((route: IRoute) => {
        return route.id === routeId;
    });
    if (route) {
        return route.path;
    }
    return routes[1].path;
}

export const routerList = formatRoutes(routes);
export default routes;
